import { HeaterBM } from '../types/BusinessModel/HeaterBM';
import { Heater } from '../types/ViewModel/Heater';

export class HeaterFactory {
    public create(data: HeaterBM): Heater {
        return new Heater(data.heaterId, data.waterInletTemperature, data.waterOutletTemperature);
    }

    public createBM(heaterId: number, waterInletTemperature: number, waterOutletTemperature: number): HeaterBM {
        return {
            heaterId: heaterId,
            waterInletTemperature: waterInletTemperature,
            waterOutletTemperature: waterOutletTemperature,
        };
    }

    public createList(data: HeaterBM[]): Heater[] {
        return data.map((h) => this.create(h));
    }
}
